module.exports = __webpack_public_path__ + "static/media/sailboat_selected_ic.1fca81e3.svg";